import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  DDP: [],
};

const DDPSlice = createSlice({
  name: "DDP",
  initialState,
  reducers: {
    updateDDP: (state, action) => {
      const index = state.DDP.findIndex(
        (item) => item.country === action.payload.country
      );
      if (index !== -1) {
        state.DDP[index] = action.payload;
      } else {
        state.DDP.push(action.payload);
      }
    },
  },
});

export const { updateDDP } = DDPSlice.actions;

export default DDPSlice.reducer;
